import React from "react";

import ArticleLayout from "../../../../components/v2/Noticias/ArticleLayout";

export default function ValeriaLopes() {
  return (
    <ArticleLayout lead="Dívida Ativa: inovação e recuperação" slug="valeria-lopes">
      <p>
        <em>
          Artigo publicado pelo Jornal O POVO em 07/04/2026 - Por: Valéria Lopes,
          Subprocuradora-Geral da PGM Fortaleza
        </em>
      </p>
      <p>
        Quando há uma dívida decorrente do não pagamento no vencimento de tributo ou outro
        crédito, o poder público é obrigado, sob pena de responsabilidade, a inscrever o
        débito em um cadastro chamado Dívida Ativa, cabendo à Procuradoria realizar o
        controle de legalidade e empregar medidas de cobrança administrativa e judicial
        para recuperá-lo.
      </p>
      <p>
        Melhorar a eficiência da recuperação envolve uma mudança de paradigma, o que
        implica em abordagens diferenciadas, conforme os perfis do devedor e da dívida.
        Economia comportamental, empatia e tecnologia são fundamentais para tornar o
        processo mais eficiente. A consensualidade, por sua vez, assume papel de destaque
        no âmbito das transações.
      </p>
      <p>
        Dentro deste cenário, a Procuradoria do Município alcançou um resultado histórico
        na recuperação dos créditos no ano de 2025, superando os três últimos anos. O
        projeto “Dívida Ativa 4.0: Transformação Digital para o Cidadão”, o qual
        conquistou o 2° lugar em premiação nacional, tem como objetivo a facilitação do
        acesso do contribuinte por meio de multicanais (portal, aplicativo de celular e
        balcão virtual) e utilização de linguagem simples.
      </p>
      <p>
        Percorrendo a jornada do usuário na negociação de débitos, pudemos avançar e
        proporcionar uma melhor experiência, consolidando o compromisso da instituição com
        a excelência na gestão pública. O impacto da atuação gerou um aumento do percentual
        de recuperabilidade em relação ao estoque, de 2,26% em 2024 para 3,71% em 2025, o
        que representou o ingresso de quase 151 milhões de reais aos cofres municipais.
      </p>
      <p>
        A experiência de Fortaleza demonstra que, quando o poder público se abre ao
        diálogo, simplifica processos e investe em tecnologia com foco nas pessoas, todos
        ganham: a cidade funciona melhor e o cidadão participa mais ativamente da
        construção das políticas públicas. Que os resultados obtidos sirvam não apenas como
        indicador de eficiência, mas como convite à continuidade dessa parceria, em que
        cada contribuinte, ao cumprir seu papel, ajuda a transformar o pagamento de
        tributos em instrumento concreto de justiça social e melhoria da qualidade de vida
        coletiva.
      </p>
    </ArticleLayout>
  );
}
